import { render, staticRenderFns } from "./ShowStatusInfo.vue?vue&type=template&id=2997d346&scoped=true"
import script from "./ShowStatusInfo.vue?vue&type=script&lang=js"
export * from "./ShowStatusInfo.vue?vue&type=script&lang=js"
import style0 from "./ShowStatusInfo.vue?vue&type=style&index=0&id=2997d346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997d346",
  null
  
)

export default component.exports